angular.module('ikeweb.folders').controller('FolderListitemController', ['$scope', 'folderService', 'events', '$translate', 'orderByFilter',
    function($scope, folderService, EVENTS, $translate, orderByFilter) {

        $scope.shownFolders = function() {
            var shownFolderIds = folderService.getVisibleFolders();
            return shownFolderIds.indexOf($scope.folder.getId()) > -1;
        };

        function isSelected() {
            return $scope.folder.isSameAs($scope.selected);
        }

        $scope.activeIfSelected = function() {
            var selected = isSelected();
            return selected ? 'FolderListitem--selected' : '';
        };

        $scope.ordinalClass = function() {
            if ($scope.folder.ordinal == null) {
                return '';
            }
            return 'FolderListitem-ordinal-' + $scope.folder.ordinal;
        };

        $scope.selectMe = function() {
            if (!isSelected()) {
                $scope.select({
                    folder: $scope.folder
                });
            }
        };

        $scope.editIfSelected = function() {
            if (!$scope.inEditMode) {
                $scope.inEditMode = isSelected();
                if ($scope.inEditMode) {
                    $scope.selectText();
                }
            }
        };

        function setFolderName(folder) {
            $scope.folderName = folder.getName();
        }

        function setSubFolders(folder) {
            $scope.subFolders = folder.subFolders;
            $scope.ordinal = folder.ordinal;
        }

        function sameName(name) {
            return function(folder) {
                return folder.getName() === name;
            };
        }

        function folderNameExists(name) {
            return $scope.folders.filter(sameName(name)).length > 0;
        }

        function notifyFolderUpdated(newFolder) {
            $scope.$emit(EVENTS.FOLDER.UPDATED, newFolder);
            return Promise.resolve();
        }

        $scope.newSubfolder = function(folder) {
            if (!$scope.canMakeSubFolder) {
                return;
            }
            var folderName = $translate.instant('COMPONENT.FOLDER.UNTITLED_FOLDER');

            while (folderNameExists(folderName)) {
                if (/\d$/.test(folderName)) {
                    folderName = folderName.replace(/\d$/, parseInt(folderName.slice(-1), 10) + 1);
                } else {
                    folderName = folderName + ' 2';
                }
            }

            return folderService.newSubfolder(folderName, folder.getId())
                .then(function(newFolder) {
                    return notifyFolderUpdated(newFolder);
                });
        };

        $scope.renameIfNecessary = function() {
            if ($scope.inEditMode && $scope.folder.getName() !== $scope.folderName) {
                folderService.rename($scope.folder, $scope.folderName)
                    .then(setFolderName, function() {
                        setFolderName($scope.folder);
                    });
            }
            $scope.inEditMode = false;
        };

        $scope.$watch('selected', function() {
            if (!isSelected()) {
                $scope.inEditMode = false;
            }
        });

        setFolderName($scope.folder);
        setSubFolders($scope.folder);
        $scope.inEditMode = false;
        $scope.$on(EVENTS.FOLDER.FOCUS, function(evt, folder) {
            if ($scope.folder.isSameAs(folder)) {
                $scope.selectMe();
                $scope.inEditMode = true;
                $scope.focus();
                $scope.selectText();
            }
        });
    }
]);



//////////////////
// WEBPACK FOOTER
// ./src/client/components/folders/folder.listitem.controller.js
// module id = 450
// module chunks = 0